import { fakers } from "@/mocks/faker";
import type { CepApiResponse } from "@shared/hooks";

const faker = fakers.clients;

export interface CnpjApiResponse {
  cnpj: string;
  razao_social: string;
  nome_fantasia: string;
  telefone: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  municipio: string;
  uf: string;
  cep: string;
  email?: string;
}

export const makeCepResponse = (
  cep: string,
  partial?: Partial<CepApiResponse>,
): CepApiResponse => ({
  cep,
  logradouro: faker.location.street(),
  complemento: faker.location.secondaryAddress(),
  bairro: faker.location.county(),
  localidade: faker.location.city(),
  uf: faker.location.state({ abbreviated: true }),
  ...partial,
});

export const makeCnpjResponse = (
  cnpj: string,
  partial?: Partial<CnpjApiResponse>,
): CnpjApiResponse => ({
  cnpj,
  razao_social: faker.company.name(),
  nome_fantasia: faker.company.name(),
  telefone: `(${faker.string.numeric(2)}) ${faker.string.numeric(5)}-${faker.string.numeric(4)}`,
  logradouro: faker.location.street(),
  numero: faker.string.numeric(3),
  complemento: faker.location.secondaryAddress(),
  bairro: faker.location.county(),
  municipio: faker.location.city(),
  uf: faker.location.state({ abbreviated: true }),
  cep: `${faker.string.numeric(5)}-${faker.string.numeric(3)}`,
  ...partial,
});
